import React from "react";
import "./Header.css";

const Header = () => {
  return (
    <header className="header">
      <div className="header-card">
        <h1 className="header-title">💳 Bill Payment API</h1>
      </div>
    </header>
  );
};

export default Header;
